<ng-container *ngIf="dialogComponentVisible">
    <app-dialog [title]="dialogTitle" [disabled]="preSelection === null" [template]="buscadorVariedad" (accepted)="onDialogAccepted($event)"></app-dialog>

    <ng-template #buscadorVariedad>
        <app-variedad-buscador [dialogMode]="true" (selectVariedad)="onSelectVariedad($event)"></app-variedad-buscador>
    </ng-template>
</ng-container>

<form class="needs-validation" [formGroup]="form" novalidate>

    <h4>{{ title }} Cultivo</h4>

    <div *ngIf="esBaja" class="nota-info warning mb-2">
        <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Cultivo dado de baja el {{ cultivo?.FechaBaja | date:'dd/MM/yyyy HH:mm' }}</label>
    </div>
    <div *ngIf="esDesautorizado" class="nota-info warning mb-2">
        <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Cultivo desautorizado</label>
    </div>

    <div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedEspecie = !isCollapsedEspecie" [attr.aria-expanded]="!isCollapsedEspecie" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos Variedad/Especie
                                <i *ngIf="isCollapsedEspecie" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedEspecie" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedEspecie" [ngbCollapse]="isCollapsedEspecie">

                                <div class="row">

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label" for="Grupo">Grupo</label>
                                        <input readonly formControlName="Grupo" name="Grupo" class="form-control" inputStyleClass="form-control" type="text">
                                    </div>

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label" for="intForma">Forma</label>
                                        <input readonly formControlName="Forma" name="Forma" class="form-control" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label" for="inpNombreComun">Nombre Común</label>
                                        <input readonly formControlName="NombreComun" name="NombreComun" class="form-control" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label required-field" for="inpNombreCientifico">Nombre Científico</label>
                                        <input readonly formControlName="NombreCientifico" name="NombreCientifico" class="form-control" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label required-field" for="inpCodigoEppo">Código Eppo</label>
                                        <input readonly formControlName="CodigoEppo" name="CodigoEppo" class="form-control" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label required-field" for="inpVariedad">Variedad</label>
                                        <div class="input-group">
                                            <input readonly formControlName="Variedad" name="Variedad" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('Variedad')" type="text" value="">
                                            <span class="input-group-btn">
                                                <button [disabled]="form.disabled || isEditMode" name="btnSearchVariedad" class="btn btn-list btn-secondary" type="button" title="Buscar Variedad - Especie" (click)="onSearchVariedad()"><i class="fa fa-search"></i></button>
                                            </span>
                                            <div id="validationIdVariedadFeedback" class="form-invalid" *ngIf="isFieldInvalid('Variedad', 'cannotBeNullOrZero', true)">
                                                Variedad obligatoria. Utilice el buscador de Variedades para seleccionarla
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatosCultivo = !isCollapsedDatosCultivo" [attr.aria-expanded]="!isCollapsedDatosCultivo" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos Cultivo
                                <i *ngIf="isCollapsedDatosCultivo" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDatosCultivo" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedLocalizacion" [ngbCollapse]="isCollapsedDatosCultivo">

                                <div class="row">

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label required-field" for="SuperficieVariedad">Superficie Dedicada (ha)</label>
                                        <input formControlName="SuperficieVariedad" name="SuperficieVariedad" maxlength="23"
                                               class="form-control" id="SuperficieVariedad" type="number" value="" min="0">
                                    </div>

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label required-field" for="ProduccionEstimada">Producción Estimada (kg)</label>
                                        <input formControlName="ProduccionEstimada" name="ProduccionEstimada" maxlength="23"
                                               class="form-control" id="ProduccionEstimada" type="number" value="" min="0">
                                    </div>

                                    <div class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label" for="identificador">Identificador</label>
                                        <input readonly formControlName="Identificador" name="Identificador" class="form-control" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div *ngIf="esBaja" class="form-group col-xl-2 col-md-4">
                                        <label class="col-form-label" for="FechaBaja">Fecha Baja</label>
                                        <p-calendar appendTo="body" formControlName="FechaBaja" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"></p-calendar>
                                    </div>
                                </div>
                                <div class="nota-info">
                                    <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Los identificadores de los cultivos se asignan de forma automática e incremental, utilizando letras y números</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col-md-12">
                    <div *ngIf="esDesautorizado" class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDesautorizados = !isCollapsedDesautorizados"
                           [attr.aria-expanded]="!isCollapsedDesautorizados" aria-controls="collapseDesautorizados">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Desautorizado en las siguientes campañas
                                <i *ngIf="isCollapsedDesautorizados" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDesautorizados" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body">
            
                            <div class="collapse group-filtros" id="collapseDesautorizados" [ngbCollapse]="isCollapsedDesautorizados">
            
                                <div class="row">
                                    <div *ngFor="let campania of cultivo?.CampaniasDesautorizado" class="nota-info">
                                        <label class="col-form-label">{{ campania?.Descripcion }} el {{ campania.Fecha | date:'dd/MM/yyyy HH:mm' }}</label>
                                    </div>
                                </div>
            
                            </div>
                        </div>
                    </div>  
                </div>

            </div>
        </div>
    </div>
</form>
